import { render, staticRenderFns } from "./Jeroen.vue?vue&type=template&id=e548e97e&scoped=true&"
import script from "./Jeroen.vue?vue&type=script&lang=js&"
export * from "./Jeroen.vue?vue&type=script&lang=js&"
import style0 from "./Jeroen.vue?vue&type=style&index=0&id=e548e97e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e548e97e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
